import { render, staticRenderFns } from "./routingInspection.vue?vue&type=template&id=072fc854&scoped=true"
import script from "./routingInspection.vue?vue&type=script&lang=js"
export * from "./routingInspection.vue?vue&type=script&lang=js"
import style0 from "./routingInspection.vue?vue&type=style&index=0&id=072fc854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072fc854",
  null
  
)

export default component.exports